import React, { useState } from "react";
import "./messages.css";

// components imports
import MessagesTable from "../../../../../Components/BoltTable/BoltTable";
// apis imports
import { fetchUserMessages } from "../../../../../services/admin.services";
import { convertTime } from "../../../../../helpers/helpers";
import { useTranslation } from "react-i18next";
// library imports

const Messages = ({ setSnack }) => {
  const { t } = useTranslation("admin");
  const [messages, setMessages] = useState([]);

  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id}</>,
      width: "200px",
    },
    {
      id: 1,
      label: t("newsletter.name"),
      render: (row) => <>{row?.name}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("newsletter.company"),
      render: (row) => <>{row?.company ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("newsletter.email"),
      render: (row) => <>{row?.email ?? "-"}</>,
      width: "200px",
    },
    {
      id: 4,
      label: t("newsletter.phone"),
      render: (row) => <>{row?.phone ?? "-"}</>,
      width: "200px",
    },
    {
      id: 5,
      label: t("newsletter.message"),
      render: (row) => <>{row?.question ?? "-"}</>,
      width: "300px",
    },
    {
      id: 6,
      label: t("newsletter.createdAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
  ];

  const getMessages = async (page, perPage, filter) => {
    const response = await fetchUserMessages(page, perPage, filter);

    if (!response.error) {
      setMessages(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  return (
    <>
      <div className="messages__main_wrap">
        <div className="messages__table_list">
          <div>
            <MessagesTable
              tableTitle={t("newsletter.messages")}
              tableId="messageTableForAdminNewsletter"
              message={t("newsletter.noMessagesAvailableToDisplay")}
              searchPlaceHolder={t("newsletter.searchMessages")}
              columns={columns}
              data={messages}
              getAllData={getMessages}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Messages;
